const LogService = {
    add(entry) {
        let log = this.get();
        let date = new Date().toISOString();

        log.unshift('[' + date + '] ' + entry)

        if (log.length > 250) {
            log.pop();
        }

        localStorage.setItem('vogt.app.logs', JSON.stringify(log));
        console.log(entry);
    },

    get() {
        let log = localStorage.getItem('vogt.app.logs');

        try {
            log = JSON.parse(log);
        } catch (error) {
            log = [];
        }

        if (!Array.isArray(log)) log = [];
        return log;
    }
}

export default LogService;